import { UIAppsBaseURLs } from '../environment/environment.model';
import {
  ApiConfigModel,
  ClientConfigModel
} from './../environment/environment-config.service';

export class UtilsService {
  /**
   * Normalize the url fragment, so that //  becomes /
   * @param uri uri to be normalized
   */
  static normalizeResourceUri(uri: string) {
    return uri.replace(/\/\//g, '/');
  }
  /**
   * Verify if the string matches the regex
   * @param stringToMatch
   * @param pattern
   */
  static matchRegex(stringToMatch: string, pattern: string): boolean {
    const re = new RegExp(`^${pattern}$`);
    return re.test(stringToMatch);
  }
  /**
   * return an entity object with the key as original url
   * and the value as overriding url
   * @param originalEnvApiConfigs the original environment api configs
   * @param overridingEnvApiConfigs the overriding environment api configs
   */
  static createApiServiceUrlOverrideList(
    originalEnvApiConfigs: ApiConfigModel,
    overridingEnvApiConfigs: ApiConfigModel
  ): { [originUrl: string]: string } {
    if (!overridingEnvApiConfigs) return {};
    return Object.keys(overridingEnvApiConfigs).reduce(
      (urlReplaceList: { [originUrl: string]: string }, apiName) => {
        const originalUrl = originalEnvApiConfigs[apiName].url;
        const overridingUrl = overridingEnvApiConfigs[apiName].url;
        return {
          ...urlReplaceList,
          [originalUrl]: overridingUrl
        };
      },
      {}
    );
  }
  /**
   * build the client url list for the navbar
   * @param clientConfigs the client configs for the current environment
   * @param currentAppName the current app name
   */
  static buildUIAppsBaseUrls(
    clientConfigs: ClientConfigModel,
    currentAppName: string
  ): UIAppsBaseURLs {
    return {
      ifta: clientConfigs.ifta.url,
      dashboard: clientConfigs.dashboard.url,
      reporting: clientConfigs.reporting.url,
      [currentAppName]: ''
    };
  }
}
